declare const __WEB_FULLERETTE_URL: string
declare const __BASE_URL: string

export const API = __BASE_URL
export const API_WEB_FULLERETTE = __WEB_FULLERETTE_URL
export const DEV_MODE = import.meta.env.MODE != "Production"

// export const ENV = __APP_ENV__
// export const API_WEB_FULLERETTE = __WEB_FULLERETTE_URL
// export const DEV_MODE = ENV != "Production"